import { render } from "./StatsWidgetMenuRender.vue?vue&type=template&id=c73004bc"
import script from "./StatsWidgetMenuRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetMenuRender.vue?vue&type=script&lang=ts"
script.render = render

export default script